import React from "react";
import ServiceWorld from "../../../components/Serviceworld/ServiceWorld";
import AdvocardFlexServiceWorld from "../../../components/Serviceworld/AdvocardFlexService/ServiceWorld";
import Layout from "../../Layouts/Layout";

import { Helmet } from "react-helmet-async";
import { useCustomer } from "../../../provider/Customer/CustomerProvider";
import { useFlexServiceLayoutForCustomer } from "../../../services/advocardService";
import { gaSet } from "../../../services/googleAnalyticsService";

const ServiceWorldPage = () => {
  const title = "Servicewelt | Legalbird";
  gaSet({ title: title });
  const { customer } = useCustomer();

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {useFlexServiceLayoutForCustomer(customer) ? <AdvocardFlexServiceWorld /> : <ServiceWorld />}
    </Layout>
  );
};

export default ServiceWorldPage;
